// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"93676f4c","545":"295fbbcf","787":"f89128b7"}[chunkId] + ".chunk.js";
};